import React from 'react';
import { useNavigate } from 'react-router-dom';

const Page404 = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center font-sans relative" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="absolute inset-0 bg-[#063a26]/40 backdrop-blur-[4px]"></div>
            
            <div className="max-w-md w-full bg-white/10 backdrop-blur-2xl border border-white/20 rounded-3xl p-10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] relative overflow-hidden z-10">
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#e6f3ec] rounded-full blur-3xl opacity-20 pointer-events-none"></div>
                <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#e7f0fd] rounded-full blur-3xl opacity-20 pointer-events-none"></div>

                <div className="relative z-10">
                    <div className="text-[120px] font-extrabold text-white leading-none tracking-tighter mb-4 opacity-40 drop-shadow-md">
                        404
                    </div>
                    
                    <div className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-2xl mx-auto flex items-center justify-center text-4xl mb-6 shadow-sm border border-white/30">
                        🧭
                    </div>

                    <h1 className="text-2xl font-bold text-white mb-3 tracking-tight drop-shadow-sm">
                        Looks like you got lost on your TRRIP!
                    </h1>
                    
                    <p className="text-white/80 text-[15px] leading-relaxed mb-8 font-medium">
                        The page you are looking for has packed its bags and moved to an unknown destination. Let's get you back to familiar territory.
                    </p>

                    <button 
                        onClick={() => navigate('/dashboard')}
                        className="bg-[#067978] hover:bg-[#045d5c] text-white font-bold py-3 px-8 rounded-full transition-all shadow-[0_8px_20px_rgba(6,121,120,0.4)] hover:shadow-[0_12px_24px_rgba(6,121,120,0.6)] hover:-translate-y-0.5 border border-[#067978]/50"
                    >
                        Return to Dashboard
                    </button>
                </div>
            </div>
            
            <div className="mt-8 text-xs font-bold tracking-widest text-white/50 uppercase z-10">
                TRRIP · Agent Portal
            </div>
        </div>
    );
};

export const NotFoundPage = Page404;
export default Page404;
